@if (showLoader) {
  <div class="loader-wrapper" [class]="cssClasses">
    <span class="loader"></span>
  </div>
}
